import React, { Component } from 'react'

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import Pagination from 'react-js-pagination';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import Box from '../ui/Box';

import NewThermostat from './NewThermostat';

//providers
import DataService from '../../services/DataService'; var ds = DataService;

export default class AllThermostats extends Component {

  constructor(props) {
    super(props);
    this.state = {
      thermoList: [],
      current_offset: 0,
      activePage: 1,
      totalCount: 0,
      maxItems: 7,
      room_id: this.props.room_main_id,
      is_edit: false,

      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  componentDidMount() {
    this.getThermoList(this.state.current_offset);
    window.addEventListener('updateThermoTable', (e) => {
      if (e.detail && e.detail == true) {
        this.refreshTable();
      }
    });
  }

  onChangePage(e) {
    this.getThermoList(this.maxItems * (e - 1));
    this.setState({
      activePage: e
    });
  }

  getThermoList(offset, offset_change = 0) {
    ds.getThermosList(this.state.room_id,
      data => {
        this.setState({
          thermoList: data
        });

        if (!offset_change) {
          let x = this.state.current_offset;
          this.setState({
            current_offset: offset + this.maxItems
          })
        }
      }, err => {}
    )

  }

  refreshTable(e) {
    this.getThermoList(this.state.current_offset - this.maxItems > 0 ? this.state.current_offset - this.maxItems : 0, 1);
  }

  closeDialog(refresh = 0) {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    });

    if (refresh) {
      this.getThermoList(0);
    }
  }

  editThermoStat(row, e) {
    this.setState({
      is_edit: <NewThermostat details={row} unMountMe={() => {
        this.setState({
          is_edit: null
        });
      }} room_main_id={this.state.room_id} />,
    });
  }

  deleteThermoStat(row, e) {
    this.setState({
      dialog: {
        open: true,
        head: 'Delete',
        body: 'Delete Thermostat permanently?',
        actions: [
          <FlatButton
            label="Delete"
            primary
            onClick={() => {
              ds.postDeleteThermostat({ device_id: row.device_id },
                data => {
                  let x = this.state.current_offset - this.state.maxItems;
                  this.closeDialog();
                  this.getThermoList(x > 0 ? x : 0, 1);

                }, err => {}
              );
            }}
          />,

          <FlatButton
            label="Cancel"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    });
  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)} 
    />

    return (
      <div>
        <Box header='Thermostat List'>
          <Dialog
            title={this.state.dialog.head}
            actions={this.state.dialog.actions}
            modal={false}
            open={this.state.dialog.open}
            onRequestClose={this.closeDialog.bind(this)}
          >
            {this.state.dialog.body || 'NA'}
          </Dialog>

          {
            this.state.is_edit ? this.state.is_edit :
            <Table
              height={'30vh'}
              fixedHeader={true}
              fixedFooter={true}
              selectable={false}
              multiSelectable={false}
              bodyStyle={{ minWidth: 680, overflowX: 'auto' }}
            >
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                  <TableHeaderColumn tooltip="Name">Name</TableHeaderColumn>
                  <TableHeaderColumn tooltip="Actions">Model Name</TableHeaderColumn>
                  <TableHeaderColumn tooltip="Actions">Brand Name</TableHeaderColumn>
                  <TableHeaderColumn tooltip="Options">Options</TableHeaderColumn>
                </TableRow>
              </TableHeader>

              <TableBody
                displayRowCheckbox={false}
                showRowHover={true}
                stripedRows={false}
              >
                {
                  this.state.thermoList.map((row, index) => (
                    <TableRow key={index}>
                      <TableRowColumn>{row.name}</TableRowColumn>
                      <TableRowColumn>{row.model}</TableRowColumn>
                      <TableRowColumn>{row.brand}</TableRowColumn>

                      <TableRowColumn>
                        <IconButton onClick={this.editThermoStat.bind(this, row)}>
                          <i className="material-icons link-fg">mode_edit</i>
                        </IconButton>
                        <IconButton onClick={this.deleteThermoStat.bind(this, row)}>
                          <i className="material-icons warn-fg">delete</i>
                        </IconButton>
                      </TableRowColumn>

                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          }
          {/* {pagination} */}
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/thermostats/AllThermostats.js